var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}]},[_c('h3',[_vm._v(_vm._s(_vm.section.libelle))]),_vm._l((_vm.filtreQuestionnaires),function(question,index){return _c('question',{key:index,attrs:{"question":question},on:{"answer":_vm.answering}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }